/** Shared role checks for routing and layout guards. */

export function normalizeRole(role) {
  return (role || '').toString().toLowerCase().trim();
}

export function isTenantUser(user) {
  if (!user) return false;
  if (normalizeRole(user.role) === 'tenant') return true;
  return Boolean(user.tenant_id);
}

export function isAdminUser(user) {
  if (!user) return false;
  return normalizeRole(user.role) === 'admin';
}

export function isOwnerUser(user) {
  const role = normalizeRole(user.role);
  return role === 'owner' || role === 'strata_manager' || role === 'admin';
}

/** Paths tenants may access under /app */
export function isTenantAllowedAppPath(pathname) {
  if (pathname === '/app/tenant' || pathname.startsWith('/app/tenant/')) return true;
  if (pathname === '/app/settings' || pathname.startsWith('/app/settings/')) return true;
  return false;
}
